export enum SourceControlType {
  Github = 'Github',
  Gitlab = 'Gitlab',
  Bitbucket = 'Bitbucket',
  Stash = 'Stash',
  Azure = 'Azure',
}

export interface PullRequest {
  sourceControlType: SourceControlType;
  issueId: string;
  appId: string;
  repo: string;
  prId: string;
  prURL: string;
  prBranchName: string;
}

export interface CreatePullRequestInput {
  prComment?: string;
  autoFixId: string;
  committer: {
    name: string;
    email: string;
  };
}

export interface RequestViewFixInput {
  sourceControlType: string;
  issueId: string;
  owner: string;
  appId: string;
  repo: string;
  originBranchName: string;
  fixFiles: FixFile[];
}

export interface FixFile {
  hashAggId: string;
  filePath: string;
  isLockFile: boolean;
}

export interface DeletePullRequestInput {
  sourceControlType: SourceControlType;
  issueId: string;
  owner: string;
  appId: string;
  repo: string;
  prId?: string;
  prBranchName: string;
}

export interface ViewFix {
  autoFixId: string;
  viewFixStatus: ViewFixStatus;
  viewFileFixes: FileFix[];
  commitMessage: string;
  prTitle: string;
  prBody: string;
}

export interface FileFix {
  diff: string;
  filePath: string;
}

export enum ViewFixStatus {
  Success = 'Success',
  Pending = 'Pending',
  Fail = 'Fail',
}
export interface GetViewFixInput {
  autoFixId: string;
}
